import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Form, Title } from 'components/layout'
import { form } from 'helpers/decorators'
import { Button, FormButton } from 'components/misc'
import { Textarea } from 'components/fields'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'
import { FormattedMessage } from 'react-intl'
import { PARTICIPANTS_BULK } from '../../../constants/enums'
import { get } from 'lodash'


const enhance = compose(
    connect(() => ({}),
        {
          modal
        }
    ),
    form({
      form: 'bulk-change-offline-award-state-modal',
      disableHook: true
    })
)

class BulkActionOfflineAwardChangeStateModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    itemCount: PropTypes.number.isRequired,
    selectedIds: PropTypes.array,
    bulkProcess: PropTypes.func,
    bulkSetResult: PropTypes.func,
    handleError: PropTypes.func,
    change: PropTypes.func,
    reset: PropTypes.func
  }

    handleBulkOfficeSignoffOfflineAward = fields => {
    const participantIds = this.props.selectedIds

    const bulkType = PARTICIPANTS_BULK.offlineToComplete.id

    const note = get(fields, 'note')

    this.props.bulkProcess(participantIds, bulkType, note)
        .then(data => {
          this.props.bulkSetResult(data.body)
          this.handleCloseModal()
          this.props.modal('bulk-change-participants-results-modal')
         })
        .catch(this.props.handleError)
  }

    handleCloseModal = () => {
        this.props.reset()
        this.props.modal(null)
    }

  render() {
    const {
      modalId,
      itemCount,
      handleSubmit
    } = this.props

    return (
        <Modal id={modalId} customActions>
          <Title h2>
              <FormattedMessage
                  id="moduleTitle.award_office_authorization_offline_award_bulk"
                  defaultMessage={`Award office authorization offline award of ${itemCount} participants.`}
                  values={{
                      itemCount: itemCount
                  }}
              />
          </Title>
          <Form
              className="form"
              onSubmit={handleSubmit(this.handleBulkOfficeSignoffOfflineAward)}
          >
            <div className="row" />
            <Textarea
              label="note"
              intlKey="label.note"
              name="note"
            />
            <div className="row">
              <div className="col-xs-6">
                <Button
                    intlKey="button.cancel"
                    onClick={() => this.handleCloseModal()}
                    secondary
                    type="button"
                    style={{ marginRight: 10 }}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <FormButton
                    {...this.props}
                    intlKey="button.approve"
                >
                  Approve
                </FormButton>
              </div>
            </div>
          </Form>
        </Modal>
    )
  }
}

export default enhance(BulkActionOfflineAwardChangeStateModal)

